
    import { debounce } from "lodash"
    import { isDev } from "./../helpers/index"

    import { defineComponent } from "@vue/runtime-core"
    import TheHeader from "@/components/TheHeader.vue"
    import InputText from "@/components/misc/InputText.vue"
    import ls from "local-storage"
    import gptAPI from "@/api/gpt"
    import { defaultTitle } from "@/main"
    import { toast } from "vue3-toastify"
    import GPTSettings, { defaultGPTSettings } from "@/components/misc/GPTSettings.vue"
    import { CreateCompletionRequest } from "openai"
    import InputSwitch from "@/components/misc/InputSwitch.vue"

    export default defineComponent({
        components: {
            InputSwitch,
            GPTSettings,
            InputText,
            TheHeader,

        },
        data() {
            return {
                gptSettings: ls("gptSettings") as any || defaultGPTSettings as Partial<CreateCompletionRequest>,
                showKeyInfo: true,
                isDev,

            }
        },
        computed: {
            hasKey(): boolean {
                return !!(ls as any)("apiKey")
            },

        },
        methods: {
            updateGPTSettings(value: Partial<CreateCompletionRequest>) {
                ls("gptSettings", value)
                this.gptSettings = value
            },

            goBack() {
                history.go(-1)
            },

            setMode(val: string) {
                ls("mode", val);
                (this.$root as any)?.updateMode(val)
            },

            setAPIKey: debounce(function(val: string) {
                ls("apiKey", val)
                gptAPI.setApiKey(val);
                // @ts-ignore
                (this.$root as any)?.updateApiKey(val)
                toast("The Key saved in local storage", { position: "bottom-right" })
                // @ts-ignore
                this.showKeyInfo = false
            }, 150),

        },

        created () {
            document.title = defaultTitle
        },

    })

  